<ng-container *ngIf="isDsdVersionVisible">
  <ng-container *ngComponentOutlet="dashboardComponent"></ng-container>
</ng-container>
